import React from 'react';
import PageTitle from './PageTitle';
import OverviewContent from '../../RnR/RnROverview/components/OverviewContent';
import SubHeading from '../../RnR/RnROverview/components/SubHeading';
import { Box, Typography } from '@mui/material';
import shabash from './assets/shabash.gif';
import { variants } from '../../../variants/variants';
import { useTheme } from '@emotion/react';

const shabashDetails = {
  name: 'Shabash',
  secondary: "What's",
  type: 'li',
  highlight: false,
  description: [
    `The "On the Spot/Shabaash" award is designed to honour individuals who excel in high-pressure situations, demonstrating exceptional abilities and achieving remarkable outcomes when faced with critical moments. These individuals possess a unique combination of skills, resilience, and determination that allow them to shine brightest when the stakes are highest.`,
    `The award recognizes not only the achievements of individuals but also their ability to thrive in adversity, adapt to changing circumstances, and deliver results that exceed expectations. It celebrates the invaluable contribution of those who demonstrate courage, resourcefulness, and ingenuity in the face of adversity, setting a benchmark for excellence and inspiring others to follow in their footsteps.`,
  ],
};

const ShabashOverview = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        background: '#fff',
        height: '86vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        border: 0.5,
        borderColor: 'divider',
        borderRadius: variants.boxRadius.MAIN,
      }}
    >
      {/* Page Header */}
      <Box
        sx={{
          flex: 0.1,
          display: 'grid',
          placeItems: 'center',
        }}
      >
        <PageTitle title="SHABASH" />
      </Box>

      {/* Container for body */}
      <Box
        sx={{
          flex: 0.9,
          maxHeight: '85vh',
          overflowY: 'auto',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'grid', width: { xl: '100%', md: '100%' } }}>
          <OverviewContent item={shabashDetails} ind={0} />
        </Box>
        <Box
          sx={{
            height: 'max-content',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            width: '100%',
          }}
        >
          <SubHeading heading={'Applicability'} />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 2,
              width: '100%',
              [theme.breakpoints.down('lg')]: {
                flexDirection: 'column',
                alignItems: 'normal',
              },
            }}
          >
            <Box sx={{ flex: 0.3, display: 'grid', placeItems: 'center' }}>
              <img src={shabash} alt="shabash" width={theme.breakpoints.down('sm') ? '90%' : '70%'} />
            </Box>
            <Box
              sx={{
                flex: 0.7,
                height: '15vh',
                overflow: 'auto',
              }}
            >
              <Typography component={'li'}>
                The applicability of this program is for team members working in Gateway Group of Companies. The purpose is to recognize,
                appreciate and motivate team members, creating an environment where individuals are driven to attain
                both personal and team accomplishments aligned with the overall growth and objectives of the
                organization.
              </Typography>
            </Box>
          </Box>
          {/* <Box sx={{ width: 'max-content', p: 1, mb: 2, textAlign: 'center' }}>
            <Typography
              component='span'
              fontWeight={'bold'}
              sx={{ fontSize: { xs: '1.5rem', lg: '1.75rem', lineHeight: 0.5 } }}
            >
              <Typography
                component='div'
                fontWeight={'bold'}
                sx={{ color: '#0a4fac', fontSize: { xs: '1.5rem', lg: '1.75rem' } }}
              >
                Nomination &
              </Typography>
              Evaluation parameters
            </Typography>
          </Box> */}
          {/* <Box
            component={BasePaper}
            elevation={3}
            sx={{
              backgroundColor: 'rgba(0,0,0,0.03)',
              width: '100%',
              p: 1,
              pt: 0,
              textAlign: 'justify',
              listStyle: 'square',
              li: {
                fontSize: { xs: '0.85rem', lg: '14px' },
              },
              '& li::marker': {
                color: '#0a4fac',
                fontSize: '1.75em',
              },
            }}
          >
            <Typography component='li'>All applicable parameters must be duly filled for each nomination.</Typography>
            <Typography component='li'>Please refer below table, which serves as guidelines for nomination.</Typography>

            <Typography component='li'>
              Nominations must be submitted without bias and along with required attachments.
            </Typography>
          </Box> */}
        </Box>
      </Box>
      {/* Dialog for view winner details */}

      {/* {selectedWinner && (
        <CustomDialogBox
          fullScreen={'fullScreen'}
          height={'100%'}
          width="60%"
          open={openDialog}
          handleClose={handleCloseDialog}
          title="Details of Request"
          content={<RequestDialog selectedWinner={selectedWinner} />}
          actions={null}
        />
      )} */}
    </Box>
  );
};

export default ShabashOverview;
